module.exports = __webpack_public_path__ + "components/app-store/static/s8-e9270dec06a54b82a57cd10386a64dac.jpg";